export class CpeTo {
    cpeName: string;
    mqUser: string;
    id: number;

    constructor(object?: any) {
        this.cpeName = object?.cpeName;
        this.mqUser = object?.mqUser;
        this.id = object?.id;
    }

}
